import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycTransferOfYourHomeAndMedicaidEligibilityPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-transfer-of-your-home-and-medicaid-eligibility/']} />;
}
